<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE7FD;</i>
          <span>Manage Global Administrators</span>
        </p>
      </div>

      <!-- Add Edit form -->
      <div class="admManageExamBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a class="searchFormLink" [showUnSavedChangesAlert]="{ form: globalAdminForm, redirect: 'AdmManageGlobalAdmin'}">Search Global Administrators</a> >
            <span class="addEditFormLink"> {{pageConfig.title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span> {{pageConfig.title}}</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="example-form" [formGroup]="globalAdminForm">
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="First Name" formControlName="firstName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Last Name" formControlName="lastName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Email" formControlName="email" maxlength="100">
                </md-form-field>
                <p class="validate" *ngIf="globalAdminForm.controls.email.value  && globalAdminForm.controls.email.errors && globalAdminForm.controls.email.errors.pattern">Incorrect Email Format</p>
              </div>

            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Phone" formControlName="contactNo" maxlength="20">
                </md-form-field>
                <p requiredField *ngIf="globalAdminForm.controls.contactNo.touched && globalAdminForm.controls.contactNo.errors && globalAdminForm.controls.contactNo.errors.required"></p>
                <p validatePhoneNumber *ngIf="globalAdminForm.controls.contactNo.touched && globalAdminForm.controls.contactNo.errors && globalAdminForm.controls.contactNo.errors.pattern"></p>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Kerberos User Name" formControlName="rhId" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf="globalAdminForm.controls.rhId.touched && globalAdminForm.controls.rhId.invalid"></p>
              </div>
            </div>

          </form>
        </md-card-content>
        <md-card-actions>
          <div class="button-row">
            <button [disabled]="globalAdminForm.invalid || pageConfig.isSaveDisable" md-raised-button class="glbAdminBtnCls1" (click)="onSave()">
              <img src="./assets/images/saveBtnIcon.png" alt="">SAVE</button>
            <button [disabled]="pageConfig.isEditDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
              <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
            <button [disabled]="pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(false)">RETIRE</button>
            <button [disabled]="this.id == 0 || !pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(true)">ACTIVATE</button>
          </div>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-global-admin/adm-update-global-admin/adm-update-global-admin.component.html